<template>
  <d2-container>
    <template slot="header">
      <el-select v-model="query.ownerType" clearable size="small" placeholder="归属类型" style="width: 150px; margin-right: 8px">
        <el-option label="个人" value="PERSONAL"></el-option>
        <el-option label="组织" value="ORGANIZATION"></el-option>
      </el-select>
      <el-input v-model="query.ownerId" clearable size="small" placeholder="归属ID" style="width: 160px; margin-right: 8px"></el-input>
      <el-select v-model="query.changeType" clearable size="small" placeholder="变动类型" style="width: 140px; margin-right: 8px">
        <el-option label="入账" value="GRANT"></el-option>
        <el-option label="消费扣减" value="RESERVE"></el-option>
        <el-option label="确认消费" value="COMMIT"></el-option>
        <el-option label="释放" value="RELEASE"></el-option>
        <el-option label="过期" value="EXPIRE"></el-option>
      </el-select>
      <el-input v-model="query.businessType" clearable size="small" placeholder="业务类型" style="width: 180px; margin-right: 8px"></el-input>
      <el-button type="primary" size="small" icon="el-icon-search" @click="load">搜索</el-button>
    </template>

    <el-table size="small" stripe border :data="records" v-loading="loading">
      <el-table-column prop="id" label="流水ID" width="150"></el-table-column>
      <el-table-column label="归属类型" width="120">
        <template slot-scope="scope">{{ ownerTypeLabel(scope.row.ownerType) }}</template>
      </el-table-column>
      <el-table-column prop="ownerId" label="归属ID" width="150"></el-table-column>
      <el-table-column label="变动类型" width="120">
        <template slot-scope="scope">{{ changeTypeLabel(scope.row.changeType) }}</template>
      </el-table-column>
      <el-table-column prop="changeAmount" label="变动无限积分" width="120" align="right"></el-table-column>
      <el-table-column prop="beforeAmount" label="变动前" width="120" align="right"></el-table-column>
      <el-table-column prop="afterAmount" label="变动后" width="120" align="right"></el-table-column>
      <el-table-column label="业务类型" width="150">
        <template slot-scope="scope">{{ businessTypeLabel(scope.row.businessType) }}</template>
      </el-table-column>
      <el-table-column prop="businessId" label="业务ID" width="150"></el-table-column>
      <el-table-column label="来源" width="150">
        <template slot-scope="scope">{{ sourceTypeLabel(scope.row.sourceType) }}</template>
      </el-table-column>
      <el-table-column label="标题" min-width="160" show-overflow-tooltip>
        <template slot-scope="scope">{{ ledgerTitleLabel(scope.row) }}</template>
      </el-table-column>
      <el-table-column prop="remark" label="备注" min-width="160" show-overflow-tooltip></el-table-column>
      <el-table-column prop="createTime" label="创建时间" width="170"></el-table-column>
    </el-table>

    <template slot="footer">
      <el-pagination
        :current-page.sync="query.currentPage"
        :page-size="query.pageSize"
        :page-sizes="[10, 20, 50, 100]"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        @size-change="handleSize"
        @current-change="handlePage"
      ></el-pagination>
    </template>
  </d2-container>
</template>

<script>
import { getAiPointLedgers } from '@/api/ai/rights'
import { businessTypeLabel, changeTypeLabel, ledgerTitleLabel, ownerTypeLabel, sourceTypeLabel } from './labels'

export default {
  name: 'aiPointLedgerManager',
  data () {
    return {
      query: { currentPage: 1, pageSize: 20, ownerType: '', ownerId: '', changeType: '', businessType: '' },
      records: [],
      total: 0,
      loading: false
    }
  },
  created () {
    this.load()
  },
  methods: {
    load () {
      this.loading = true
      getAiPointLedgers(this.query).then(res => {
        this.records = (res && res.records) || []
        this.total = Number((res && res.total) || 0)
      }).finally(() => {
        this.loading = false
      })
    },
    handleSize (size) {
      this.query.pageSize = size
      this.load()
    },
    handlePage (page) {
      this.query.currentPage = page
      this.load()
    },
    ownerTypeLabel,
    changeTypeLabel,
    businessTypeLabel,
    sourceTypeLabel,
    ledgerTitleLabel
  }
}
</script>
